import React, { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import car from '../../../../../assets/ImagesDefaults/ic-img-default-vehicle.svg';
import { status, STATUS_MODEL } from '../../../../../enums/statusEnum';
import { GetProviderVehicleDetail } from '../../../../../reduxToolkit/Providers/providersApi';
import { CustomCardGrid } from '../../../../../components/CustomCardGrid';
import ButtonActionsCard from '../../../../../components/buttons/ButtonActionsCard';
import RowCardText from '../../../../../components/RowCardText';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import NotInformation from '../../../../../components/NotInformation';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../../Routes/routes';
import { EMPTY_VALUES} from '../../../../../Apis/functions';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { ArrowRightIcon, IconColorPalette, ModelIcon } from '../../../../../components/buttons/IconButtons';

const AllVehiclesCards = ({
    handleCheckboxChange,
    selectVehicleForDelete,
    vehicleData,
    elementRef,
    view,
    page,
    rowsPerPage,
    isAllChecked,
    handleCheckedAll,
    disabled = false,
    isSectionEmployee = false,
    byVehicleId = false,
    classNamePanelGrid = '',
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { searchByFilters } = useSelector((state) => state.SearchSlice);
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));

    useLayoutEffect(() => {
        if (elementRef?.current && view === VIEW_TYPE.GRID.name) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [view, searchByFilters, page, rowsPerPage]);

    const handleOnClick = (contractorId, supplierId, item) => {
        const goApproveDocuments = item?.statusId === STATUS_MODEL.TO_APPROVE_DOCUMENT;
        let vehicleId = byVehicleId ? item?.vehicleId : item?.id;
        if (contractorId || supplierId) {
            dispatch(GetProviderVehicleDetail(vehicleId));
            sessionStorage.setItem('vehicleidfordetail', vehicleId);
        }
        if (contractorId) {
            navigate(
                goApproveDocuments
                    ? `${routes.vehicleContractor.document}${vehicleId}`
                    : `${routes.vehicleContractor.details}${vehicleId}`,
            );
        } else if (supplierId) {
            navigate(goApproveDocuments ? `${routes.vehicleSupplier.document}` : `${routes.vehicleSupplier.details}`);
        } else {
            navigate(`${routes.vehicleFleet.details}${vehicleId}`);
        }
    };

    return (
        <>
            {vehicleData?.content?.length > 0 ? (
                <>
                    <div className={''}>
                        <CustomCheckbox
                            id={'cb_av_all_checked'}
                            trans={'de_/_select_all'}
                            name={'isAllChecked'}
                            checked={isAllChecked}
                            onChange={(e) => {
                                handleCheckedAll(e);
                            }}
                        />
                    </div>
                    <div className='panelTables' ref={elementRef}>
                        <div className='row'>
                            {vehicleData?.content?.map((item, index) => (
                                <CustomCardGrid
                                    itemId={item?.id}
                                    checked={selectVehicleForDelete?.includes(item?.id)}
                                    onCheckboxChange={handleCheckboxChange}
                                    disabled={disabled}
                                    statusName={t(status[item?.statusId])}
                                    srcImage={item?.image ? `data:image/png;base64,${item?.image}` : car}
                                    backgroundImage={item?.image ? `data:image/png;base64,${item?.image}` : ''}
                                    btnActions={
                                        <ButtonActionsCard
                                            id={`btn_avc_actions_card_${index + 1}`}
                                            name={item.statusId === STATUS_MODEL.TO_APPROVE_DOCUMENT ? 'complete_documents' : 'details'}
                                            Icon={ArrowRightIcon}
                                            onClick={() => {
                                                handleOnClick(contractorId, supplierId, item);
                                            }}
                                        />
                                    }
                                    classNamePanelGrid={classNamePanelGrid}
                                >
                                    <div className='d-flex justify-content-center align-items-center my-2 text-center'>
                                        <p className='ibl-h3 font-color-general-950 ibl-font-w-600 m-0'>
                                            {item?.brand} - {item?.subBrand}
                                        </p>
                                    </div>

                                    <div className='border-bottom-shades-300 mb-3 ' />
                                    <div className='d-flex align-items-center my-2'>
                                        <ModelIcon className='w-20px h-20px' />
                                        <RowCardText
                                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                                            classNameValue='fs-14px ibl-font-w-300 '
                                            classNameTitle='fs-14px ibl-font-w-600 '
                                            title={t('model')}
                                            value={item?.model || EMPTY_VALUES.DEFAULT}
                                        />
                                    </div>
                                    <div className='d-flex align-items-center my-2'>
                                        <IconColorPalette className='w-20px h-20px' />
                                        <RowCardText
                                            className='my-2 ml-3 d-flex justify-content-between overflow-hidden'
                                            classNameValue='fs-14px ibl-font-w-300 '
                                            classNameTitle='fs-14px ibl-font-w-600 '
                                            title={t('color')}
                                            value={item?.color || EMPTY_VALUES.DEFAULT}
                                        />
                                    </div>
                                </CustomCardGrid>
                            ))}
                        </div>
                    </div>
                </>
            ) : (
                <NotInformation text={t('no_information')} card={true} />
            )}
        </>
    );
};

export default AllVehiclesCards;
